import { useEditMode } from "@/contexts/EditModeContext";
import { useAuth } from "@/contexts/AuthContext";
import { Pencil, X, Eye, EyeOff, GripVertical, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const EditModeToolbar = () => {
  const { isEditMode, setEditMode } = useEditMode();
  const { isAdmin } = useAuth();

  if (!isAdmin) return null;

  if (!isEditMode) {
    return (
      <button
        onClick={() => setEditMode(true)}
        className="fixed bottom-6 right-6 z-50 bg-primary text-primary-foreground p-3 rounded-full shadow-xl hover:bg-primary/90 transition-all hover:scale-105"
        title="Ativar modo de edição"
      >
        <Pencil size={20} />
      </button>
    );
  }

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-card border border-border px-5 py-3 rounded-2xl shadow-2xl">
      <div className="flex items-center gap-2 text-sm font-medium text-primary">
        <Pencil size={16} />
        <span>Modo Editor</span>
      </div>
      <div className="w-px h-6 bg-border" />
      <p className="text-xs text-muted-foreground max-w-[200px]">
        Clique numa secção para editar
      </p>
      <div className="w-px h-6 bg-border" />
      <Button
        size="sm"
        variant="ghost"
        onClick={() => setEditMode(false)}
        className="text-destructive hover:text-destructive"
      >
        <X size={16} />
        Sair
      </Button>
    </div>
  );
};

export default EditModeToolbar;
